'use strict';

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var recaptcha = require('ba-base/components/reCaptcha');
var sectionsCompleted = [];
var lastInputChange = null;
var submitBtnClicked = false;

var registrationSubmit = function (e) {
    var form = $('form.registration'),
        url = form.attr('action'),
        $accountSuccessModal = $('#signup-modal');

    $('form.registration').trigger('login:register', e);

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            form.spinner().stop();
            if (!data.success) {
                formValidation(form, data);
                submitBtnClicked = false;
                $('html, body').animate({
                    scrollTop: $('.form-control.is-invalid').offset().top - $('header').height()
                }, 500);
            } else if ($accountSuccessModal.length) {
                if (data.redirectUrl) {
                    $accountSuccessModal.data('redirect-link', data.redirectUrl);
                }
                $accountSuccessModal.modal('show');
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'customerCreation',
                    customerNo: data.customerNo,
                    accountType: data.accountType
                });
            } else {
                location.href = data.redirectUrl;
            }

            $accountSuccessModal.on('hide.bs.modal', function () {
                location.href = data.redirectUrl;
            });
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
            }
            form.spinner().stop();
        }
    });
    return false;
};

/**
 * sendCompletedStep is used for GTM
 * @param {Object} stepName - the element that triggered the event
 **/
function sendCompletedStep(stepName) {
    if (sectionsCompleted.indexOf(stepName) <= -1) {
        sectionsCompleted.push(stepName);
        var data = {
            stepName: stepName
        };
        $('body').trigger('gtm:application:stepCompleted', data);
    }
}

/**
 * checkPersonalDetailsComplete
 */
function checkPersonalDetailsComplete() {
    var isComplete = true;
    $('.personal-details').each(function () {
        var input = $(this).find('input');
        if (!input) {
            input = $(this).find('select');
        }
        if ($(input).prop('required')) {
            if ($(input).val().length < 1) {
                isComplete = false;
            }
        }
    });
    if (isComplete) {
        sendCompletedStep('Personal Details');
    }
}
/**
 * checkBusinessDetailsComplete
 */
function checkBusinessDetailsComplete() {
    var isComplete = true;
    $('.business-details').each(function () {
        var input = $(this).find('input');
        if (!input) {
            input = $(this).find('select');
        }
        if ($(input).prop('required')) {
            if ($(input).val().length < 1) {
                isComplete = false;
            }
        }
    });
    if (isComplete) {
        sendCompletedStep('Business Details');
    }
}

/**
 * checkBusinessLicenseComplete
 */
function checkBusinessLicenseComplete() {
    if ($('.create-account-licence').find('input').length > 0) {
        if ($('.create-account-licence').find('input').get(0).files.length !== 0) {
            sendCompletedStep('Business License');
        }
    }
}

/**
 * checkTaxExemptComplete
 */
function checkTaxExemptComplete() {
    var isComplete = false;
    $('.create-account-taxsection').find('input[type="checkbox"]').each(function () {
        isComplete = isComplete || $(this).is(':checked');
    });

    if (isComplete) {
        sendCompletedStep('Tax Exempt');
    }
}

/**
 * checkTellUsMoreComplete
 */
function checkTellUsMoreComplete() {
    var isComplete = false;
    $('.tellsu-more-option').each(function () {
        isComplete = isComplete || $(this).is(':checked');
    });

    if (isComplete) {
        sendCompletedStep('Tell Us More');
    }
}


module.exports = {
    sectionsCompleted: sectionsCompleted,
    lastInputChange: lastInputChange,
    submitBtnClicked: submitBtnClicked,
    init: () => {
        $('#sms-optin').on('click', function () {
            let $numCntr = $('#mobile-input-container'),
                $input = $('#sms-number-input');

            if ($(this).is(':checked')) {
                $numCntr.removeClass('hide');
                $input.prop('required', true);
            } else {
                $input.val('');
                $numCntr.addClass('hide');
                $input.prop('required', false);
            }
        });
    },
    register: function () {
        $('form.registration').submit(function (e) {
            e.preventDefault();

            if (SitePreferences.RECAPTCHA_ENABLED) {
                recaptcha.showReCaptcha('registration-form');
            } else {
                registrationSubmit(e);
            }
        });
    },

    handleAwsUpload: function () {
        $('body').on('filePrecheck:error', function (e, data) {
            if (data && data.element && data.message) {
                var $errContainer = $(data.element).closest('.file-upload').find('.aws-invalid-feedback');
                if ($errContainer) {
                    $errContainer.html(data.message);
                }
                // Handle login page (go to first error field)
                var $parent = $('.aws-invalid-feedback');
                var $header = $('header');
                var headerHeight = $header ? $header.height() : 0;
                var target = ($parent.offset().top) - headerHeight - 100;
                $('html, body').animate({ scrollTop: target }, 1000);
            }
            e.stopPropagation();
            e.stopImmediatePropagation();
        });
    },
    cancelResetPassword: function () {
        $('.cancel-reset-password').on('click', function () {
            window.history.back();
        });
    },

    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        formValidation(form, data);
                    } else if (document.referrer) {
                        window.history.back();
                    } else {
                        window.location.href = './';
                    }
                },
                error: function () {
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    preventPOBoxAsTradeAddress: function () {
        $(document).on('change', 'input[name$="tradeMasterProfile_address_address1"]', function () {
            $('button.create-account-submit').attr('disabled', false);
            var shippingsPO = ['Postal Office Box', 'P.O. Box', 'PO Box', 'PObox', 'Pobox', 'Po Box', 'P.OBox', 'P.O Box', 'po box', 'POBox', 'POBOX', 'PO BOX', 'PO box', 'P.O.Box', 'p.o. box', 'pobox', 'P.O.Box', 'P.O.BOX', 'P.O. BOX', 'P.O. box', 'P. O. Box', 'P. O.Box', 'P. O. BOX', 'POB', 'P.O.B', 'P. O. B', 'P.O.B.', 'P. O. B.', 'Post Box', 'PostBox', 'PostOfficeBox', 'Post Office Box', 'PostOffice Box', 'Post OfficeBox', 'PostOfficeBin', 'Post Office Bin', 'Post OfficeBin', 'PostOffice Bin', 'Post Box#', 'PostBox#', 'PostBox #', 'Post Box', 'p o box'];
            var inputTradeAddress = $('input[name$="tradeMasterProfile_address_address1"]').val();
            for (var i = 0; i < shippingsPO.length; i++) {
                if (inputTradeAddress.indexOf(shippingsPO[i]) !== -1) {
                    $(this).addClass('is-invalid');
                    $(this).siblings('.invalid-feedback').html('Please note we do not ship to P.O. boxes. For shipping assistance, call 843 723 8140.');
                    $('button.create-account-submit').attr('disabled', true);
                    break;
                } else {
                    $(this).removeClass('is-invalid');
                }
            }
        });
    },

    preventPOBoxAsNonTradeAddress: function () {
        $(document).on('change', 'input[name$="tradeSubProfile_address_address1"]', function () {
            $('button.create-account-submit').attr('disabled', false);
            var shippingsPO = ['Postal Office Box', 'P.O. Box', 'PO Box', 'PObox', 'Pobox', 'Po Box', 'P.OBox', 'P.O Box', 'po box', 'POBox', 'POBOX', 'PO BOX', 'PO box', 'P.O.Box', 'p.o. box', 'pobox', 'P.O.Box', 'P.O.BOX', 'P.O. BOX', 'P.O. box', 'P. O. Box', 'P. O.Box', 'P. O. BOX', 'POB', 'P.O.B', 'P. O. B', 'P.O.B.', 'P. O. B.', 'Post Box', 'PostBox', 'PostOfficeBox', 'Post Office Box', 'PostOffice Box', 'Post OfficeBox', 'PostOfficeBin', 'Post Office Bin', 'Post OfficeBin', 'PostOffice Bin', 'Post Box#', 'PostBox#', 'PostBox #', 'Post Box', 'p o box'];
            var inputNonTradeAddress = $('input[name$="tradeSubProfile_address_address1"]').val();
            for (var i = 0; i < shippingsPO.length; i++) {
                if (inputNonTradeAddress.indexOf(shippingsPO[i]) !== -1) {
                    $(this).addClass('is-invalid');
                    $(this).siblings('.invalid-feedback').html('Please note we do not ship to P.O. boxes. For shipping assistance, call 843 723 8140.');
                    $('button.create-account-submit').attr('disabled', true);
                    break;
                } else {
                    $(this).removeClass('is-invalid');
                }
            }
        });
    },

    initRecaptcha: function () {
        var formRegistration = $('form.registration');

        if (SitePreferences.RECAPTCHA_ENABLED && formRegistration.length > 0) {
            recaptcha.attach(formRegistration, registrationSubmit);
        }

        recaptcha.init();
    },

    // Validation for Tell us more section
    tellusMoreValidation: function () {
        var $tellusMoreValid = $('.tellsu-more'),
            $tellusMoreOption = $('.tellsu-more-option'),
            $tellusmoreText = $('.tellsu-more-text');

        $tellusMoreOption.on('change', function () {
            var tellusMoreChecked = $('.tellsu-more-option[type=checkbox]:checked').length;

            if (tellusMoreChecked < 1) {
                $tellusmoreText.addClass('error-text');
                $tellusMoreValid.prop('required', true);
                $tellusMoreValid.prop('checked', false);
            } else {
                $tellusmoreText.removeClass('error-text');
                $tellusMoreValid.removeClass('is-invalid');
                $tellusMoreValid.prop('required', false);
                $tellusMoreValid.prop('checked', true);
            }
        });
    },

    // Validation for DBA name input
    dbaNameValidation: function () {
        var $dbaOptions = $('.uselegalname-wrapper input'),
            $dbaWrapper = $('.dbaname-wrapper'),
            $dbaInput = $('#dbaname');

        $dbaOptions.on('change', function () {
            if ($(this).hasClass('display-dbaname')) {
                $dbaWrapper.removeClass('d-none');
                $dbaInput.prop('required', true);
            } else {
                $dbaWrapper.addClass('d-none');
                $dbaInput.prop('required', false);
                $dbaInput.val('');
            }
        });
    },

    // Files upload validation
    filesValidation: function () {
        var $fileWrapper = $('.file-wrapper'),
            $fileCheckbox = $fileWrapper.find('.custom-control-input').not('.clean-tax-options'),
            $taxNaCheckbox = $('.tax-input-na');

        $fileCheckbox.on('change', function () {
            var $this = $(this),
                $thisFileItem = $this.closest('.file-wrapper').find('.file-item');

            if ($this.is(':checked')) {
                $thisFileItem.find('.s3upload').prop('required', true);
                $thisFileItem.removeClass('d-none');
                $('.clean-tax-options').prop('checked', false);

                $taxNaCheckbox.prop('required', false);
                $taxNaCheckbox.removeClass('is-invalid');
            } else {
                $thisFileItem.find('.s3upload').prop('required', false);
                $thisFileItem.addClass('d-none');
            }

            if (!$fileWrapper.find('.custom-control-input:checked').length) {
                $taxNaCheckbox.prop('required', true);
            }
        });
    },

    // Clean upload checkbox functionality
    cleanFiles: function () {
        var $fileWrapper = $('.file-wrapper'),
            $fileCheckbox = $fileWrapper.find('.custom-control-input').not('.clean-tax-options'),
            $fileInput = $fileWrapper.find('.s3upload');

        $('.clean-tax-options').on('change', function () {
            var $this = $(this);

            if ($this.is(':checked')) {
                $fileCheckbox.prop('checked', false);
                $fileInput.prop('required', false);
                $('.file-item').addClass('d-none');
                $('.tax-input-na').prop('required', true);

                $fileInput.each(function (index, input) {
                    var $input = $(input);

                    if ($input.val().length) {
                        // if file was uloaded, remove it
                        $input.siblings('.file-upload-after').children('.file-upload-remove-container').trigger('click');
                    }
                });
            }
        });
        $('body').on('aws:clearfiles', function (e, data) {
            if (data.element) {
                var $invalidElement = $(data.element).closest('.file-upload').find('.aws-invalid-feedback');
                $invalidElement.html('');
            }
        });
    },

    toggleTellUsMoreTextarea: function () {
        $('.tellsu-more-option').on('change', function () {
            if ($(this).val() === 'OTHER') {
                var $self = $(this),
                    $heardOfUs = $('.heard-of-us'),
                    $textArea = $('#heardAboutUs');

                if ($self.is(':checked')) {
                    $heardOfUs.removeClass('d-none');
                    $textArea.attr('required', 'required');
                } else {
                    $heardOfUs.addClass('d-none');
                    $textArea.removeAttr('required');
                }
            }
        });
    },

    handleTaxExemptCheckbox: function () {
        $(document).on('change', '#taxNa', function () {
            var taxNotProvided = $('#taxNotProvide');
            if (taxNotProvided.is(':checked')) {
                taxNotProvided.prop('checked', false);
            }
        });

        $(document).on('change', '#taxNotProvide', function () {
            var taxNa = $('#taxNa');
            taxNa.prop('required', false);
            if (taxNa.is(':checked')) {
                taxNa.prop('checked', false);
            }
        });
    },

    gtmFunctions: function () {
        var isCreateAccountPage = $('.create-account').length > 0;
        if (isCreateAccountPage) {
            $(document).on('change', 'input,select', function () {
                var id = $(this).attr('id');
                if (id.indexOf('businessLicense') > -1) {
                    id = 'businessLicense';
                }

                lastInputChange = id;

                checkPersonalDetailsComplete();
                checkBusinessDetailsComplete();
                checkBusinessLicenseComplete();
                checkTaxExemptComplete();
                checkTellUsMoreComplete();
            });

            $('.create-account-submit').on('click', function () {
                submitBtnClicked = true;
            });

            $(window).on('unload', function () {
                if (lastInputChange !== null && !submitBtnClicked) {
                    var data = {
                        fieldName: lastInputChange
                    };
                    $('body').trigger('gtm:application:abandon', data);
                }
            });
        }
    }
};
